import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/siteData";

// Mobile-only tap-to-call floating button.
// Lives in the bottom-right corner on screens < md. Uses the tel: protocol
// so tapping opens the native dialer. Complements — does not replace —
// the primary form-based CTAs elsewhere on the site.

export const MobileCallButton = () => {
  const dialNumber = COMPANY.phone.replace(/[^+\d]/g, "");

  return (
    <a
      href={`tel:${dialNumber}`}
      aria-label={`Call ${COMPANY.phone}`}
      data-testid="mobile-call-fab"
      className="md:hidden fixed bottom-5 right-5 z-40 group flex items-center gap-2 bg-coral text-white pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_rgba(237,125,101,0.45)] active:scale-95 transition-transform"
    >
      <span className="relative flex w-9 h-9 items-center justify-center rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/25 animate-ping opacity-60" aria-hidden="true" />
        <Phone size={18} strokeWidth={2} className="relative" />
      </span>
      <span className="text-sm font-medium tracking-wide">Call us</span>
    </a>
  );
};

export default MobileCallButton;
